import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { CLIQLOAN_BRAND } from "../../theme/cliqloanBrand";
import { CLIQLOAN_TYPO } from "../../theme/cliqloanTypography";

function BannerMain() {
  return (
    <Box
      sx={{
        background: "#23244F",
        py: { xs: 7, sm: 9, md: 11 },
        px: 2,
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" maxWidth={760} mx="auto">
          <Typography
            component="h1"
            sx={{
              fontFamily: CLIQLOAN_TYPO.fontFamily,
              fontWeight: 700,
              ...CLIQLOAN_TYPO.hero,
              color: CLIQLOAN_BRAND.white,
              mb: 2,
            }}
          >
            CliQloan Blog
          </Typography>
          <Typography
            sx={{
              fontFamily: CLIQLOAN_TYPO.fontFamily,
              fontWeight: 400,
              fontSize: "clamp(1rem, 1.54vw, 1.31rem)",
              lineHeight: 1.24,
              color: "rgba(255,255,255,0.92)",
            }}
          >
            Your Guide to Efficient Loan Processing
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default BannerMain;
